import React, { createContext, useContext, useState, useCallback } from "react";

const SectorPersonnelContext = createContext(null);

export function SectorPersonnelProvider({ children }) {
  const [sectorPersonnel, setSectorPersonnelState] = useState({});

  const setSectorPersonnel = useCallback((updater) => {
    setSectorPersonnelState(typeof updater === "function" ? updater : (() => updater));
  }, []);

  const value = { sectorPersonnel, setSectorPersonnel };
  return (
    <SectorPersonnelContext.Provider value={value}>
      {children}
    </SectorPersonnelContext.Provider>
  );
}

export function useSectorPersonnel() {
  const ctx = useContext(SectorPersonnelContext);
  if (!ctx) {
    throw new Error("useSectorPersonnel must be used within SectorPersonnelProvider");
  }
  return ctx;
}

export default SectorPersonnelContext;
